// src/app/quill-config.ts
import QuillResizeImage from '@lokesh-stack/advanced-quill-image-resize';
import Quill from 'quill';

import { CustomIframeBlot } from './layout/quill-editor/custom-iframe-blot';
import { CustomImageBlot } from './layout/quill-editor/custom-image-blot';

Quill.register(CustomIframeBlot);
Quill.register(CustomImageBlot, true);
Quill.register("modules/resize", QuillResizeImage);
